import definedSchemas from 'components/forms/fields/definedSchemas';
const fields = {
    lastName: {
        ...definedSchemas.textRequired,
        label: 'Last Name',
    },
    refNumber: {
        ...definedSchemas.mmcNumberRequired,
        label: 'Reference Number',
    },
};

export default fields;
